import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
const ButtonsGroup = ({ justify = 'start', wrap = 'wrap', direction = 'row', children, }) => {
    return (_jsx("div", { className: `buttons-group buttons-justify--${justify} buttons-direction--${direction}`, style: { flexWrap: wrap }, children: children }));
};
export default ButtonsGroup;
